import(/* webpackMode: "eager" */ "/codebuild/output/src1006363581/src/nextjs-grudder/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1006363581/src/nextjs-grudder/src/app/auth/login/login-form.tsx");
